import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({ 
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.css']
})
export class FeedbackFormComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec:EncryptDecryptService,private route: Router,public translate: TranslateService) { }
  plugin_menu_dtl:any;
  content_apiresponse:any;
  feedback:any;
  sucess_message: any;
  status:any;
  captchaImg: any = '';
  captchaInput: any = null;
  captchaData: any = '';
  captchaImgDisplay = false; 
  language:any = "";

  employee_con:any="";
  showEmpMen:boolean=false;
  showNavComponent:boolean=false;
  showBarComponent:boolean=false;
  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }

  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime(); 
  ngOnInit(): void {
    this.getAllZoneData();
    this.language = sessionStorage.getItem('locale');//dynamic
    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if(this.employee_con==null){
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
    this.fciwebservice.getCaptcha().subscribe((res: any) => {
      if (res.status == 200) {
        this.captchaImg = 'data:image/jpg;base64,' + res.imgBs64;
        this.captchaData = res.imgTxt;
        this.captchaImgDisplay = true;
      }
    });
  }

  reloadCaptcha() {
    this.captchaImgDisplay = false;
    this.fciwebservice.getCaptcha().subscribe((res: any) => {
      if (res.status == 200) {
        this.captchaImg = 'data:image/jpg;base64,' + res.imgBs64;
        this.captchaData = res.imgTxt;
        this.captchaImgDisplay = true;
      }
    });
  }
  FeedbackForm = new FormGroup({
    name: new FormControl('',[Validators.required, Validators.pattern('[a-zA-Z ]+$')]),
    contactNum: new FormControl('',[Validators.required, Validators.pattern('[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]),
    email: new FormControl('' ,[Validators.required,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
    rating: new FormControl(''),
    timetaken: new FormControl(''),
    concerns: new FormControl(''),
    comments: new FormControl(''),
    captcha: new FormControl('',),
   
    
  })
  get captcha() {
    return this.FeedbackForm.get('captcha');
  }
  get email() {
    return this.FeedbackForm.get('email');
  }
  get name() {
    return this.FeedbackForm.get('name');
  }
  get contactNum() {
    return this.FeedbackForm.get('contactNum');
  }
 
  submitVigilanceForm(){
    
    var data = this.FeedbackForm.value;
    let params = {
      "formData":data,
      "captchaData" : this.captchaData,
      "ZONE_ID"     :this.CURRENT_ZONE_ID,
      "REGION_ID"    : this.CURRENT_REGION_ID,
      "ZONE_CODE"     : this.CURRENT_ZONE_CODE,
      "REGION_CODE"    : this.CURRENT_REGION_CODE
   };
   if (data.captcha == '' || typeof (data.captcha) == undefined || data.captcha == null) {

    Swal.fire({
      icon: 'error',
      text: ('Enter Captcha Code')
    });
   
  }
  else{
    this.fciwebservice.submitVigilanceForm(params).subscribe((response:any) => {
      this.content_apiresponse = response;
      let respData = this.content_apiresponse.RESPONSE_DATA;
      let respToken = this.content_apiresponse.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response);
          if(response.original.message == 'success'){
            this.status= true;
            this.sucess_message = "Vigilance Feedback submitted sucessfully";
            setTimeout(() => {
              this.status=  false
            }, 4000);
            this.FeedbackForm.reset();
            this.reloadCaptcha();
         } 
         else if(response.original.message == 'invalid'){
      
          Swal.fire({
            icon: 'error',
            text: "Invalid Captcha"
          });
        
        }

        else if(response.original.message == 'Invalid Content'){     
          Swal.fire({
            icon: 'error',
            text: "Invalid Content. Scrpts OR Tags are not allowed!"
          }); 
        }
        
         else {
          this.status=  false
          this.sucess_message = "";
         }
      }  else{
        this.status= false;
      }
      
    });
  }
   }




  emp_apires:any;
  emp_dtl:any={'title':''};
  getEmployeeCornerDtl(id:any){
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [ 
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break; 
        case HttpEventType.Response:
        this.emp_apires = response.body;
        let respData = this.emp_apires.RESPONSE_DATA;
        let respToken = this.emp_apires.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.result.sec_1.length > 0){
            this.emp_dtl=response_.result.sec_1[0];
            this.showBarComponent=true;
            this.showEmpMen = true;
          }
        } 
      }
    });
  }

  navmenuloadCss = "background-color: #167a44; height: 100%;";
  p_apirespons: any;
  P_data: any;

  navMenu:boolean=false;
  getPluginPageDetials(details:any) {
    let params;
    if(details!==null){
      let d = JSON.parse(details);
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link':d.selectPlugin,
        'localdata':true,
      };
    } else{
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link':this.CurrentRouteFn(),
        'localdata':false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
        this.p_apirespons = response.body;
        let respData = this.p_apirespons.RESPONSE_DATA;
        let respToken = this.p_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.original.status){
            this.P_data = response_.original;
            this.navMenu = response_.original.hasMenu;
            this.navmenuloadCss = "height: 100%;";
          } else {
            this.P_data = response_.original;//somthing wrong
          }
          this.showNavComponent=true;
          this.showBarComponent=true;
        } 
      }
    });
  }


  zoneList:any = [];  
  getAllZoneData(){
    
      this.fciwebservice.getDemographicZone({'demo_type':1}).subscribe((response: HttpEvent<any>) => {
        
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.zoneList = response.result;
             
            } 
          }
      
        });
  }

  ZoneChange(val:any){
    this.getAllRegionZonewise(val);
  }

  regionList:any = [];  
  getAllRegionZonewise(val:any){
    // console.log(val);
    if(val==0 || val==""){
      this.regionList = [];
    }
      this.fciwebservice.getAllRegionZonewise({'int_Parent_Id':val}).subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.regionList = response.result;
             
            } 
          }
        
        //  console.log(this.regionList);
      });
    }
  }






